import { render, staticRenderFns } from "./TurnPrintLabel.vue?vue&type=template&id=51789424"
import script from "./TurnPrintLabel.vue?vue&type=script&lang=js"
export * from "./TurnPrintLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports